// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
  Josh's Custom CSS Reset
  https://www.joshwcomeau.com/css/custom-css-reset/
*/

*,
*::before,
*::after {
  box-sizing: border-box;
}

* {
  margin: 0;
}

body {
  line-height: 1.5;
  -webkit-font-smoothing: antialiased;
}

img,
picture,
video,
canvas,
svg {
  display: block;
  max-width: 100%;
}

input,
button,
textarea,
select {
  font: inherit;
}

p,
h1,
h2,
h3,
h4,
h5,
h6 {
  overflow-wrap: break-word;
}

p {
  text-wrap: pretty;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  text-wrap: balance;
}

#root,
#__next {
  isolation: isolate;
}

/* End of CSS reset */

:root {
  --bg-color-dark: hsl(50, 100%, 80%);
  --bg-color: hsl(50, 100%, 60%);
  --bg-color-light: hsl(50, 100%, 40%);

  --text-color: hsl(50, 15%, 15%);
}

body, html {
   display: flex;
   flex-direction: column;
   justify-content: center;
   align-items: center;
   height: 100%;
   font-family: Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
   background: linear-gradient(hsl(52, 100%, 50%), hsl(45, 100%, 50%));
   color: var(--text-color);
}

.upcoming-weather-cards {
  display: grid;
  grid-template-columns: repeat(5, 200px);
  grid-template-rows: 150px;
  gap: 1rem;
  margin-top: 1rem;
}

.content {
  width: 1160px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  box-shadow: inset 0px 0px 15px black;
}

.middle-row {
  display: grid;
  grid-auto-flow: column;
  grid-template-columns: 2fr, 1fr;
  grid-template-rows: 400px;
  gap: 1rem;
}

.content > * {
  margin-bottom: 1rem;
}

img {
  align-self: center;
  width: 480px;
  height: 400px;
  border-radius: 100px;
}

.todays-weather, .weather-card {
  display: grid;
  grid-template-rows: min-content min-content min-content min-content min-content;
  border: 1px solid black;
  border-radius: 1rem;
  padding: 1rem;
  box-shadow: 0px 3px 3px black;
  background: #FFF;
  transition: 500ms;
  background: var(--bg-color);
}

.todays-weather {
  width: 600px;
}

.todays-weather:hover, .weather-card:hover {
  transform: translateY(-5px);
  transition: 500ms;
  box-shadow: 0px 2px 7px black;
}

#search-city {
  width: 600px;
  height: 30px;
  border-radius: 1rem;
  border: 1px solid var(--bg-color-light);
  padding-left: 0.5rem;
  box-shadow: 0px 0px 2px black;
}

#search-button {
  border-radius: 2rem;
  background: none;
  width: 1.75rem;
  height: 1.75rem;
  border: 1px solid var(--bg-color-light);
  position: relative;
  cursor: pointer;
  align-self: center;
  box-shadow: 0px 0px 2px black;
}

#search-button:hover {
  border: 1px solid var(--bg-color);
  box-shadow: 0px 0px 5px var(--text-color);
}

.card-date {
  justify-self: end;
  align-self: end;
  color: rgb(50, 46, 46);
}

.content {
  border: 1px solid black;
  padding: 3rem;
  border-radius: 2rem;
  background: var(--bg-color-dark);
  padding-bottom: 2rem;
}

.searchImg {
  position: absolute;
  width: 1rem;
  height: 1.5rem;
  top: 0;
}

.search-section {
  position: relative;
  margin-bottom: 2rem;
}

form {
  display: flex;
  gap: 0.5rem;
}

#gifImage {
  box-shadow: 0px 0px 5px black;
}

#C-F {
  color: var(--bg-color-light);
  cursor: pointer;
}

.active {
  color: hsl(47, 100%, 42%);
  font-size: 1.2rem;
}`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAAA;;;CAGC;;AAED;;;EAGE,sBAAsB;AACxB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;;;;;EAKE,cAAc;EACd,eAAe;AACjB;;AAEA;;;;EAIE,aAAa;AACf;;AAEA;;;;;;;EAOE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;;;;;EAME,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA,qBAAqB;;AAErB;EACE,mCAAmC;EACnC,8BAA8B;EAC9B,oCAAoC;;EAEpC,+BAA+B;AACjC;;AAEA;GACG,aAAa;GACb,sBAAsB;GACtB,uBAAuB;GACvB,mBAAmB;GACnB,YAAY;GACZ,yFAAyF;GACzF,mEAAmE;GACnE,wBAAwB;AAC3B;;AAEA;EACE,aAAa;EACb,uCAAuC;EACvC,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,+BAA+B;EAC/B,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,+EAA+E;EAC/E,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,6BAA6B;EAC7B,gBAAgB;EAChB,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,uCAAuC;EACvC,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,uCAAuC;EACvC,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,iCAAiC;EACjC,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,cAAc;EACd,MAAM;AACR;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB","sourcesContent":["/*\n  Josh's Custom CSS Reset\n  https://www.joshwcomeau.com/css/custom-css-reset/\n*/\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\n* {\n  margin: 0;\n}\n\nbody {\n  line-height: 1.5;\n  -webkit-font-smoothing: antialiased;\n}\n\nimg,\npicture,\nvideo,\ncanvas,\nsvg {\n  display: block;\n  max-width: 100%;\n}\n\ninput,\nbutton,\ntextarea,\nselect {\n  font: inherit;\n}\n\np,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  overflow-wrap: break-word;\n}\n\np {\n  text-wrap: pretty;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  text-wrap: balance;\n}\n\n#root,\n#__next {\n  isolation: isolate;\n}\n\n/* End of CSS reset */\n\n:root {\n  --bg-color-dark: hsl(50, 100%, 80%);\n  --bg-color: hsl(50, 100%, 60%);\n  --bg-color-light: hsl(50, 100%, 40%);\n\n  --text-color: hsl(50, 15%, 15%);\n}\n\nbody, html {\n   display: flex;\n   flex-direction: column;\n   justify-content: center;\n   align-items: center;\n   height: 100%;\n   font-family: Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;\n   background: linear-gradient(hsl(52, 100%, 50%), hsl(45, 100%, 50%));\n   color: var(--text-color);\n}\n\n.upcoming-weather-cards {\n  display: grid;\n  grid-template-columns: repeat(5, 200px);\n  grid-template-rows: 150px;\n  gap: 1rem;\n  margin-top: 1rem;\n}\n\n.content {\n  width: 1160px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  box-shadow: inset 0px 0px 15px black;\n}\n\n.middle-row {\n  display: grid;\n  grid-auto-flow: column;\n  grid-template-columns: 2fr, 1fr;\n  grid-template-rows: 400px;\n  gap: 1rem;\n}\n\n.content > * {\n  margin-bottom: 1rem;\n}\n\nimg {\n  align-self: center;\n  width: 480px;\n  height: 400px;\n  border-radius: 100px;\n}\n\n.todays-weather, .weather-card {\n  display: grid;\n  grid-template-rows: min-content min-content min-content min-content min-content;\n  border: 1px solid black;\n  border-radius: 1rem;\n  padding: 1rem;\n  box-shadow: 0px 3px 3px black;\n  background: #FFF;\n  transition: 500ms;\n  background: var(--bg-color);\n}\n\n.todays-weather {\n  width: 600px;\n}\n\n.todays-weather:hover, .weather-card:hover {\n  transform: translateY(-5px);\n  transition: 500ms;\n  box-shadow: 0px 2px 7px black;\n}\n\n#search-city {\n  width: 600px;\n  height: 30px;\n  border-radius: 1rem;\n  border: 1px solid var(--bg-color-light);\n  padding-left: 0.5rem;\n  box-shadow: 0px 0px 2px black;\n}\n\n#search-button {\n  border-radius: 2rem;\n  background: none;\n  width: 1.75rem;\n  height: 1.75rem;\n  border: 1px solid var(--bg-color-light);\n  position: relative;\n  cursor: pointer;\n  align-self: center;\n  box-shadow: 0px 0px 2px black;\n}\n\n#search-button:hover {\n  border: 1px solid var(--bg-color);\n  box-shadow: 0px 0px 5px var(--text-color);\n}\n\n.card-date {\n  justify-self: end;\n  align-self: end;\n  color: rgb(50, 46, 46);\n}\n\n.content {\n  border: 1px solid black;\n  padding: 3rem;\n  border-radius: 2rem;\n  background: var(--bg-color-dark);\n  padding-bottom: 2rem;\n}\n\n.searchImg {\n  position: absolute;\n  width: 1rem;\n  height: 1.5rem;\n  top: 0;\n}\n\n.search-section {\n  position: relative;\n  margin-bottom: 2rem;\n}\n\nform {\n  display: flex;\n  gap: 0.5rem;\n}\n\n#gifImage {\n  box-shadow: 0px 0px 5px black;\n}\n\n#C-F {\n  color: var(--bg-color-light);\n  cursor: pointer;\n}\n\n.active {\n  color: hsl(47, 100%, 42%);\n  font-size: 1.2rem;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
